import { render, staticRenderFns } from "./DECPContent.vue?vue&type=template&id=79ddd75a&"
import script from "./DECPContent.vue?vue&type=script&lang=js&"
export * from "./DECPContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports